const TIME = 180000

export default {
  TIME
}
